/**
 * Classes Nice estáticas baseadas no CSV oficial do INPI
 * Atualizado em: 07/10/2025
 * Fonte: classes-nice.csv
 */

export const CLASSES_NICE = [
  { codigo: '*', especificacao: 'Todas as Classes' },
  {
    codigo: '01',
    especificacao: 'Substâncias químicas destinadas à indústria, às ciências, à fotografia, assim como à agricultura, à horticultura e à silvicultura; Resinas artificiais não processadas, matérias plásticas não processadas; Adubo, fertilizantes; Composições extintoras de fogo e para sua prevenção; Preparações para temperar e soldar; Substâncias químicas destinadas a conservar alimentos; Substâncias para curtir peles de animais e couro; Substâncias adesivas destinadas à indústria; Massas e outras substâncias de preenchimento; Preparações biológicas destinadas à indústria e à ciência.',
    nota_explicativa: 'produtos químicos destinados à indústria, à ciência e à agricultura, incluindo os que entram na composição de produtos que façam parte de outras classes.'
  },
  {
    codigo: '02',
    especificacao: 'Tintas, vernizes, lacas; Preservativos contra oxidação e contra deterioração da madeira; Corantes e substâncias tintoriais; Tintas para imprimir, marcar e gravar; Mordentes; Resinas naturais em estado bruto; Metais em folhas e em pó para uso em pintura, decoração, impressão e arte.',
    nota_explicativa: 'tintas, corantes e preparações de proteção contra a corrosão.'
  },
  {
    codigo: '03',
    especificacao: 'Preparações cosméticas e de toalete não medicinais; Dentifrícios não medicinais; Perfumaria, óleos essenciais; Preparações para branquear e outras substâncias para uso em lavanderia; Preparações para limpar, polir e decapar, preparações abrasivas',
    nota_explicativa: 'produtos de limpeza e produtos de toalete que não sejam de uso medicinal, bem como preparações destinadas à limpeza doméstica e de outros ambientes.'
  },
  {
    codigo: '04',
    especificacao: 'Graxas e óleos industriais, cera; Lubrificantes; Composições para absorver, molhar e ligar pó; Combustíveis e agentes para iluminação; Velas e pavios para iluminação',
    nota_explicativa: 'graxas e óleos industriais, combustíveis e agentes de iluminação.'
  },
  {
    codigo: '05',
    especificacao: 'Preparações farmacêuticas, medicinais e veterinárias; Preparações higiênicas para fins medicinais; Alimentos e substâncias dietéticos adaptados para uso medicinal ou veterinário, alimentos para bebês; Suplementos alimentares para seres humanos e animais; Emplastros, materiais para curativos; Material para obturações dentárias, cera dentária; Desinfetantes; Preparações para destruição de pragas; Fungicidas, herbicidas.',
    nota_explicativa: 'farmacêuticas e outras de uso medicinal ou veterinário.'
  },
  {
    codigo: '06',
    especificacao: 'Metais comuns e suas ligas, minérios; Materiais de metal para construção e edificação; Construções transportáveis de metal; Cabos e fios não elétricos de metal comum; Pequenos artigos de ferragem; Contêineres de metal para armazenagem e transporte; Cofres.',
    nota_explicativa: 'metais comuns não processados e semiprocessados, incluindo minérios, bem como certos produtos feitos de metais comuns'
  },
  {
    codigo: '07',
    especificacao: 'Máquinas, máquinas-ferramentas, ferramentas elétricas; Motores, exceto para veículos terrestres; Engates de máquinas e componentes de transmissão, exceto para veículos terrestres; Instrumentos agrícolas, exceto ferramentas manuais de propulsão muscular; Chocadeiras; Máquinas de autosserviço.',
    nota_explicativa: 'máquinas e máquinas-ferramentas e motores.'
  },
  {
    codigo: '08',
    especificacao: 'Ferramentas e instrumentos manuais, de propulsão muscular; Cutelaria; Armas portáteis, exceto de fogo; Lâminas de barbear',
    nota_explicativa: 'ferramentas e instrumentos operados manualmente para a realização de tarefas, tais como: furar, perfurar, modelar e cortar.'
  },
  {
    codigo: '09',
    especificacao: 'Aparelhos e instrumentos científicos, de pesquisa, de navegação, geodésicos, fotográficos, cinematográficos, audiovisuais, ópticos, de pesagem, de medição, de sinalização, de detecção, de teste, de inspeção, de salvamento e de ensino; Aparelhos e instrumentos para conduzir, interromper, transformar, acumular, regular ou controlar a distribuição ou o uso de eletricidade; Aparelhos e instrumentos para gravar, transmitir, reproduzir ou processar som, imagens ou dados; Mídias gravadas e baixáveis, programas de computador, mídias virgens digitais ou analógicas para gravação e armazenamento; Mecanismos para aparelhos operados com moedas; Caixas registradoras, dispositivos para calcular; Computadores e dispositivos periféricos de computadores; Trajes e máscaras de mergulho, protetores de ouvidos para mergulhadores, clipes nasais para mergulhadores e nadadores, luvas para mergulhadores, aparelhos de respiração para nado subaquático; Aparelhos extintores de incêndio',
    nota_explicativa: 'aparelhos e instrumentos para fins científicos ou de pesquisa, equipamentos audiovisuais e de tecnologia da informação, assim como equipamentos de segurança e de salvamento.'
  },
  {
    codigo: '10',
    especificacao: 'Aparelhos e instrumentos cirúrgicos, médicos, odontológicos e veterinários; Membros, olhos e dentes artificiais; Artigos ortopédicos; Materiais de sutura; Dispositivos terapêuticos e de assistência adaptados para pessoas com deficiência; Aparelhos de massagem; Aparelhos, dispositivos e artigos para amamentação; Aparelhos, dispositivos e artigos de uso sexual.',
    nota_explicativa: 'aparelhos, instrumentos e artigos cirúrgicos, médicos, odontológicos e veterinários geralmente utilizados para o diagnóstico, tratamento ou melhoria das funções ou condições de pessoas e animais.'
  },
  {
    codigo: '11',
    especificacao: 'Aparelhos e instalações para fins de iluminação, aquecimento, resfriamento, produção de vapor, cozimento, secagem, ventilação, fornecimento de água e higiene.',
    nota_explicativa: 'aparelhos e instalações para intervir em ambientes, em particular, para fins de iluminar, cozinhar, resfriar e higienizar.'
  },
  {
    codigo: '12',
    especificacao: 'Veículos; Aparelhos para locomoção por terra, ar ou água.',
    nota_explicativa: 'veículos e equipamentos para o transporte de pessoas ou mercadorias por terra, ar ou água.'
  },
  {
    codigo: '13',
    especificacao: 'Armas de fogo; Munições e projéteis; Explosivos; Fogos de artifício.',
    nota_explicativa: 'armas de fogo e produtos pirotécnicos.'
  },
  {
    codigo: '14',
    especificacao: 'Metais preciosos e suas ligas; Joias, bijuterias, pedras preciosas e semipreciosas; Relojoaria e instrumentos cronométricos.',
    nota_explicativa: 'metais preciosos e certos produtos feitos de metais preciosos ou folheados, bem como joalheria, bijuteria, relojoaria e seus componentes.'
  },
  {
    codigo: '15',
    especificacao: 'Instrumentos musicais; Estantes [pedestais] para partituras e suportes para instrumentos musicais; Batutas para regentes.',
    nota_explicativa: 'instrumentos musicais, suas partes e seus acessórios.'
  },
  {
    codigo: '16',
    especificacao: 'Papel e papelão; Material impresso; Artigos para encadernação; Fotografias; Artigos de papelaria e materiais para escritório, exceto móveis; Adesivos para papelaria ou uso doméstico; Materiais para artistas e para desenho; Pincéis; Materiais de instrução e ensino; Folhas, filmes e bolsas plásticas para embrulhar e embalar; Caracteres de imprensa, clichês.',
    nota_explicativa: 'papel, papelão e certos produtos feitos destes materiais, bem como artigos de escritório.'
  },
  {
    codigo: '17',
    especificacao: 'Borracha, guta-percha, goma, amianto, mica e substitutos para todos estes materiais, não processados ou semiprocessados; Plásticos e resinas extrudados para uso na indústria; Materiais para calafetar, vedar e isolar; Canos, tubos e mangueiras flexíveis, não metálicos.',
    nota_explicativa: 'matérias plásticas e materiais isolantes elétricos, térmicos ou acústicos para uso em processos de manufatura na forma de folhas, blocos e barras, bem como certos produtos feitos de borracha, guta-percha, goma, amianto, mica e seus substitutos.'
  },
  {
    codigo: '18',
    especificacao: 'Couro e imitações de couro; Peles e couros de animais; Bagagens e bolsas; Guarda-chuvas e guarda-sóis; Bengalas; Chicotes, arreios e selaria; Coleiras, guias e roupas para animais.',
    nota_explicativa: 'couro, imitações de couro e certos produtos feitos destes materiais.'
  },
  {
    codigo: '19',
    especificacao: 'Materiais, não metálicos, para edificação e construção; Canos rígidos, não metálicos, para construção; Asfalto, piche, alcatrão e betume; Construções transportáveis, não metálicas; Monumentos, não metálicos.',
    nota_explicativa: 'materiais, não metálicos, para edificação e construção.'
  },
  {
    codigo: '20',
    especificacao: 'Móveis, espelhos, molduras; Recipientes não metálicos para armazenagem e transporte; Osso, chifre, barbatana de baleia ou madrepérola não trabalhados ou semitrabalhados; Conchas; Espuma-do-mar; Âmbar amarelo.',
    nota_explicativa: 'os móveis e suas partes, bem como certos produtos feitos de madeira, cortiça, junco, cana, vime, chifre, osso, barbatana de baleia, concha, âmbar, madrepérola, espuma-do-mar e sucedâneos de todas estas matérias ou de plástico.'
  },
  {
    codigo: '21',
    especificacao: 'Utensílios e recipientes para a casa ou cozinha; Utensílios de cozinha e de mesa, exceto garfos, facas e colheres; Pentes e esponjas; Escovas e pincéis, exceto para pintura; Materiais para fabricação de escovas; Objetos para limpeza; Vidro não trabalhado ou semitrabalhado, exceto para construção; Artigos de vidro, porcelana e faiança.',
    nota_explicativa: 'pequenos utensílios e aparelhos para uso doméstico e para cozinha, acionados manualmente, assim como utensílios cosméticos e utensílios de toalete, artigos de vidro e certos produtos feitos de porcelana, cerâmica, faiança, terracota ou vidro.'
  },
  {
    codigo: '22',
    especificacao: 'Cordas e cordéis; Redes; Tendas e oleados; Toldos de materiais têxteis ou sintéticos; Velas de embarcações; Sacos para transporte e armazenagem de materiais a granel; Matérias para enchimento, amortecimento e estofamento, exceto papel, papelão, borrachas e plásticos; Matérias têxteis fibrosas em bruto e seus substitutos.',
    nota_explicativa: 'lonas e outros materiais para fabricação de velas de embarcações, cordoaria, materiais de enchimento, acolchoamento, amortecimento e estofamento e matérias têxteis fibrosas em estado bruto.'
  },
  {
    codigo: '23',
    especificacao: 'Fios e linhas para uso têxtil.',
    nota_explicativa: 'fios e linhas naturais ou sintéticos para uso têxtil.'
  },
  {
    codigo: '24',
    especificacao: 'Tecidos e substitutos de tecidos; Roupas de cama, mesa e banho; Cortinas têxteis ou de plástico.',
    nota_explicativa: 'tecidos e coberturas em tecido para uso doméstico.'
  },
  {
    codigo: '25',
    especificacao: 'Vestuário, calçados, chapelaria.',
    nota_explicativa: 'roupas, calçados e peças de chapelaria para seres humanos.'
  },
  {
    codigo: '26',
    especificacao: 'Rendas, tranças [galão] e bordados, e fitas e laços de armarinho; Botões, colchetes e ilhoses, alfinetes e agulhas; Flores artificiais; Enfeites de cabelo; Cabelos postiços.',
    nota_explicativa: 'artigos de passamanaria e de armarinho, cabelos naturais ou sintéticos, enfeites de cabelo, assim como pequenos adornos para uma variedade de objetos, não incluídos em outras classes.'
  },
  {
    codigo: '27',
    especificacao: 'Carpetes, tapetes, capachos e esteiras, linóleo e outras coberturas para assoalhos já existentes; Colgaduras que não sejam em matérias têxteis.',
    nota_explicativa: 'produtos destinados a recobrir ou revestir assoalhos ou paredes previamente construídos.'
  },
  {
    codigo: '28',
    especificacao: 'Jogos, joguetes e brinquedos; Aparelhos de videogame; Artigos para ginástica e esporte; Decorações para árvores de Natal.',
    nota_explicativa: 'brinquedos, aparelhos para jogos, equipamentos de esporte, itens lúdicos e brinquedinhos, assim como certos artigos para árvores de Natal.'
  },
  {
    codigo: '29',
    especificacao: 'Carne, peixe, aves e caça; Extratos de carne; Frutas, legumes e verduras em conserva, congelados, secos e cozidos; Geleias, gelatinas e compotas; Ovos; Leite, queijo, manteiga, iogurte e outros laticínios; Óleos e gorduras comestíveis',
    nota_explicativa: 'gêneros alimentícios de origem animal, assim como frutas, verduras e legumes e outros produtos hortícolas comestíveis, preparados ou conservados para consumo.'
  },
  {
    codigo: '30',
    especificacao: 'Café, chá, cacau e sucedâneos destes; Arroz, massas, macarrões instantâneos; Tapioca e sagu; Farinhas e preparações feitas de cereais; Pão, pastelaria e confeitos; Chocolate; Sorvetes, sorbets e outros gelados comestíveis; Açúcar, mel, xarope de melaço; Lêvedo, fermento em pó; Sal, temperos, especiarias, ervas em conserva; Vinagre, molhos e outros condimentos; Gelo.',
    nota_explicativa: 'gêneros alimentícios de origem vegetal, exceto frutas, verduras e legumes, preparados ou conservados para consumo, assim como produtos destinados a melhorar o sabor dos alimentos.'
  },
  {
    codigo: '31',
    especificacao: 'Produtos agrícolas, hortícolas, florestais e de aquacultura crus e não processados; Grãos e sementes crus e não processados; Frutas, legumes e verduras frescos e ervas frescas; Plantas e flores naturais; Bulbos, mudas e sementes para plantio; Animais vivos; Alimentos e bebidas para animais; Malte.',
    nota_explicativa: 'produtos da terra e do mar que não tenham recebido qualquer preparação para consumo, animais vivos e plantas vivas, assim como alimentos para animais.'
  },
  {
    codigo: '32',
    especificacao: 'Cervejas; Bebidas não alcoólicas; Águas minerais e gasosas; Bebidas de fruta e sucos de fruta; Xaropes e outras preparações para fazer bebidas não alcoólicas.',
    nota_explicativa: 'bebidas não alcoólicas, assim como cervejas'
  },
  {
    codigo: '33',
    especificacao: 'Bebidas alcoólicas, exceto cervejas; Preparações alcoólicas para fazer bebidas.',
    nota_explicativa: 'bebidas alcoólicas, essências e extratos'
  },
  {
    codigo: '34',
    especificacao: 'Tabaco e sucedâneos do tabaco; Cigarros e charutos; Cigarros eletrônicos e vaporizadores para fumantes; Artigos para fumantes; Fósforos.',
    nota_explicativa: 'tabaco e artigos usados para fumar, assim como certos acessórios e recipientes relacionados com o uso dos mesmos.'
  },
  {
    codigo: '35',
    especificacao: 'Propaganda; Gestão, organização e administração de negócios; Funções de escritório.',
    nota_explicativa: 'serviços que envolvem gestão de negócios, operação, organização e administração de uma empresa comercial ou industrial, assim como serviços de publicidade e propaganda, marketing e promocionais. Para fins de classificação, a venda de produtos não é considerada um serviço.'
  },
  {
    codigo: '36',
    especificacao: 'Serviços financeiros, monetários e bancários; Serviços de seguros; Negócios imobiliários.',
    nota_explicativa: 'serviços relacionados a transações bancárias e outras transações financeiras, serviços de avaliação financeira, assim como atividades imobiliárias e securitárias.'
  },
  {
    codigo: '37',
    especificacao: 'Serviços de construção civil; Serviços de instalação e reparo; Extração mineral, perfuração de petróleo e de gás.',
    nota_explicativa: 'serviços no segmento de construção civil, assim como serviços que envolvam a restauração de objetos ao seu estado original ou sua conservação, sem alterar suas condições físicas ou químicas.'
  },
  {
    codigo: '38',
    especificacao: 'Serviços de telecomunicações.',
    nota_explicativa: 'serviços que possibilitem a, pelo menos, uma parte comunicar-se com outra, assim como serviços para a radiodifusão e transmissão de dados.'
  },
  {
    codigo: '39',
    especificacao: 'Transporte; Embalagem e armazenagem de produtos; Organização de viagens.',
    nota_explicativa: 'serviços prestados para o transporte de pessoas, animais ou mercadorias de um lugar para outro por ferrovias, rodovias, água, ar ou dutos, e serviços necessariamente ligados a tal tipo de transporte, assim como a armazenagem de produtos em qualquer tipo de depósito, entrepostos ou outros tipos de edificações para sua conservação ou guarda.'
  },
  {
    codigo: '40',
    especificacao: 'Tratamento de materiais; Reciclagem de resíduo e lixo; Purificação de ar e tratamento de água; Serviços de impressão; Conservação de alimentos e bebidas.',
    nota_explicativa: 'os serviços prestados por meio de produção, transformação ou processamento químico ou mecânico de objetos, ou de substâncias orgânicas ou inorgânicas, incluindo serviços de fabricação sob medida. Para fins de classificação, a produção ou manufatura de um produto é considerada como um serviço somente nos casos em que ela for feita a mando de terceiro, mediante suas solicitação e especificações. Caso a referida produção ou manufatura não seja feita a pedido de terceiro, de acordo com suas necessidades, exigências ou especificações, tal atividade é geralmente considerada como decorrente da atividade comercial principal do fabricante ou de seus produtos no mercado. Se a substância ou o objeto for comercializado para terceiros pela pessoa que o processou, transformou ou produziu, isto geralmente não seria considerado um serviço.'
  },
  {
    codigo: '41',
    especificacao: 'Educação; Provimento de treinamento; Entretenimento; Atividades desportivas e culturais.',
    nota_explicativa: 'serviços que consistam em todas as formas de educação ou treinamento, serviços que tenham o objetivo básico de entretenimento, diversão ou recreação de pessoas, bem como a apresentação de obras de artes visuais ou literatura ao público para fins culturais ou educativos.'
  },
  {
    codigo: '42',
    especificacao: 'Serviços científicos e tecnológicos, e pesquisa e projeto relacionados a estes; Serviços de análise industrial, pesquisa industrial e desenho industrial; Serviços de controle de qualidade e autenticação; Projeto e desenvolvimento de hardware e de software de computador.',
    nota_explicativa: 'serviços prestados por pessoas relacionados aos aspectos teóricos e práticos de campos complexos de atividades, por exemplo, serviços de laboratórios científicos, engenharia, programação de computadores, serviços de arquitetura ou design de interiores.'
  },
  {
    codigo: '43',
    especificacao: 'Serviços de fornecimento de comida e bebida; Acomodações temporárias.',
    nota_explicativa: 'serviços relacionados ao preparo de comidas e bebidas para consumo, assim como serviços para o provimento de acomodação temporária.'
  },
  {
    codigo: '44',
    especificacao: 'Serviços médicos; Serviços veterinários; Serviços de higiene e beleza para seres humanos ou animais; Serviços de agricultura, de aquacultura, de horticultura e de silvicultura.',
    nota_explicativa: 'médicos, incluindo medicina alternativa, serviços de higiene corporal e beleza prestados por pessoas ou estabelecimentos a seres humanos ou animais, assim como serviços relacionados ao campo da agricultura, aquacultura, horticultura e silvicultura.'
  },
  {
    codigo: '45',
    especificacao: 'Serviços jurídicos; Serviços de segurança para proteção física de bens tangíveis e de pessoas; Serviços de encontros, serviços de redes sociais on-line; Serviços funerários; Serviços de babá.',
    nota_explicativa: 'serviços jurídicos e de segurança, assim como certos serviços pessoais e sociais prestados por terceiros para satisfazer a necessidade de indivíduos.'
  }
];

// Função para buscar classe por código
export const getClasseNiceByCode = (codigo) => {
  return CLASSES_NICE.find(classe => classe.codigo === codigo);
};

// Função para buscar classes por texto (para autocomplete)
export const searchClassesNice = (searchTerm) => {
  if (!searchTerm) return CLASSES_NICE;
  
  const term = searchTerm.toLowerCase();
  return CLASSES_NICE.filter(classe => 
    classe.codigo.toLowerCase().includes(term) ||
    classe.especificacao.toLowerCase().includes(term) ||
    (classe.nota_explicativa && classe.nota_explicativa.toLowerCase().includes(term))
  );
};

// Função para obter especificação resumida (primeiras 80 caracteres)
export const getClasseResumo = (codigo) => {
  const classe = getClasseNiceByCode(codigo);
  if (!classe || classe.codigo === '*') return classe?.especificacao || '';
  
  const resumo = classe.especificacao.length > 80 
    ? classe.especificacao.substring(0, 80) + '...' 
    : classe.especificacao;
  
  return `${codigo} - ${resumo}`;
};

export default CLASSES_NICE;
